import React, { useContext, useState, useRef, useEffect } from "react";
import ReactDOM from 'react-dom';

import { Card } from "react-bootstrap"

import { useTranslation } from "react-i18next";

import ProfileVerify from "../../../../components/Templates/Site/ProfileVerify";

import { IconButton } from "@fluentui/react";
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';

import { __FormulaId, __KPIAgregations, __KPIPeriods, __MasterKPIStatusId, __MessageTypes } from "../../../../common/Dictionaries";

import { addMasterKpi, addMasterKpiList, deleteMasterKpi, getMasterKpiById, saveMasterKpiById } from "../../../../services/sKPI/masterKpi.service";

import TemplateDoc from '../../../../templates/sKPI/Mantainers/tmp_MasterKpis.csv'

import { useGetMasterKpisMaintainer } from "../../../../hooks/services/sKPI/useOfMasterKpi";
import { useGetTypeOfs } from "../../../../hooks/services/sKPI/useOfTypeOf";
import { useGetMeasurementUnit } from "../../../../hooks/services/sKPI/useOfMeasurementUnit";
import { useGetObjetives } from "../../../../hooks/services/sKPI/useOfObjetive";

import { downloadCSV, getGridLocalization, isNullUndefinedOrEmpty, showMessage } from "../../../../common/Helpers";
import MessageBox from "../../../../components/Common/Message/MessageBox";
import MainAppContext from "../../../../MainAppContext";
import * as XLSX from 'xlsx';
import MatrixToolbar from "../../../../components/Products/sPrivilege/Matrix/MatrixToolbar";
import { applyFilters, executeScrollMovementToFixLockRowOnEditCell, handlerFilter, removeGridLocalStorageFilters, setterActionFired, useFilterActionComponentData } from "../../../../common/Helpers/JqxGridFilter";
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
export default function MasterKpi(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)

    const gridRef = useRef();
    const fileInputRef = useRef(null);

    const [showRequiredGlobalMessage, setShowRequiredGlobalMessage] = useState(false);
    const [editingRows, setEditingRows] = useState([]);

    const listFormulaId = __FormulaId.filter(x => !x.disabled).map(item => { return { ...item, text: t(item.text), title: t(item.title) } });
    const listStatusId = __MasterKPIStatusId.map(item => { return { ...item, text: t(item.text), title: t(item.title) } });
    const listPeriods = __KPIPeriods.map(item => { return { ...item, text: t(item.text), title: t(item.title) } });
    const listAgregations = __KPIAgregations.map(item => { return { ...item, text: t(item.text), title: t(item.title) } });

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [listTypeOfs, setListTypeOfs] = useState(null);
    useGetTypeOfs(listTypeOfs, setListTypeOfs)

    const [listMeasurmentUnits, setListMeasurmentUnits] = useState(null);
    useGetMeasurementUnit(listMeasurmentUnits, setListMeasurmentUnits)

    const [listObjectives, setListObjectives] = useState(null);
    useGetObjetives(listObjectives, setListObjectives)

    const [listMasterKpis, setListMasterKpis] = useState(null);
    useGetMasterKpisMaintainer(listMasterKpis, setListMasterKpis)

    useFilterActionComponentData(gridRef, messageConfig, "MantainerMasterKpi");

    useEffect(() => {
        if (listMasterKpis === null) {
            removeGridLocalStorageFilters("MantainerMasterKpi")
        }

    }, [listMasterKpis]);

    const handlerAddNewRow = (obj) => {
        const _lowerId = listMasterKpis.length !== 0 ? listMasterKpis.reduce((min, obj) => obj.id < min ? obj.id : min, listMasterKpis[0].id) : 0;
        const lowerId = listMasterKpis.length === 0 ? -1 : (_lowerId > 0 ? ((_lowerId * -1) - 1) : _lowerId -1);

        const newRow = !obj ? {
            id                      : lowerId,
            masterKpiCode           : "",
            name                    : "",
            descripcion             : "",
            typeOfId                : null,
            measurementUnitId       : null,
            objetiveId              : null,
            measurementPeriodId     : null,
            timeAggregationId       : null,
            formulaId               : null,
            statusId                : null,
        } : {
            id                      : lowerId,
            masterKpiCode           : obj.masterKpiCode,
            name                    : obj.name,
            descripcion             : obj.descripcion,
            //businessName            : obj.businessName,
            //legalEntityIdentifier   : obj.legalEntityIdentifier,
            typeof                  : obj.typeof,
            typeOfId                : obj.typeOfId,
            measurementUnitId       : obj.measurementUnitId,
            objetiveId              : obj.objetiveId,
            measurementPeriodId     : obj.measurementPeriodId,
            timeAggregationId       : obj.timeAggregationId,
            formulaId               : obj.formulaId,
            statusId                : obj.statusId
        };

        gridRef.current.beginupdate();
        gridRef.current.addrow(null, newRow, 'first');

        listMasterKpis.unshift(newRow);
        setListMasterKpis(listMasterKpis);

        if (editingRows.length > 0 ? editingRows.find(x => x === lowerId) === undefined : true) {
            editingRows.push(lowerId)
            setEditingRows(editingRows);
        }

        gridRef.current.endupdate();
        gridRef.current.updatebounddata('rows');
        setterActionFired("MantainerMasterKpi", 1)
    };

    const handlerUploadData = () => {
        fileInputRef.current.click();
    };

    const handlerFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const convertedData = jsonData.slice(1).map((row, rowIndex) => {
                const convertedRow = {};
                row.forEach((cell, columnIndex) => {
                    const columnName = getColumns().find(x => x.index === columnIndex).dataField;
                    convertedRow[columnName] = cell;
                });

                convertedRow.id = null;

                return convertedRow;
            });

            convertedData.forEach(element => {
                handlerAddNewRow(element)
            });
        };

        reader.readAsArrayBuffer(file);
        fileInputRef.current.value = '';
    };

    const getValue = (column, row) => {
        const itemValue = column.editorOptions.find(x => x.key === row[column.dataField])

        return !isNullUndefinedOrEmpty(itemValue) ? itemValue.text : "";
    };

    const handlerExportData = (exportData) => {
        const workbook = XLSX.utils.book_new();

        const aux_rows = []

        if (exportData) {
            const aux_list = listMasterKpis.filter(x => x.id > 0);

            aux_list.forEach(row => {
                let aux_row = {};
                getColumns().forEach(column => {
                    if (column.exportable) {
                        if (column.columntype === 'dropdownlist') {
                            aux_row[column.dataField] = row[column.dataField] !== null ? getValue(column, row) : "";
                        }
                        else {
                            aux_row[column.dataField] = row[column.dataField];
                        }
                    }
                });
    
                aux_rows.push(aux_row);
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(aux_rows, { header: getColumns().filter(x => (exportData ? x.exportable : x.uploadMasive)).map(column => column.dataField) });
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

        if (exportData) {
            XLSX.writeFile(workbook, 'MasterKpi_ExportedData.xlsx');
        }
        else {
            XLSX.writeFile(workbook, 'MasterKpi_UploadTemplate.xlsx');
        }
    };

    const isInValidFormControls = (list) => {
        let isInvalidForm = false;

        return isInvalidForm;
    };

    const handlerSaveAll = () => {

        //Obtener todos los elementos con id 0, ya que estos son los elementos a agregar.
        //Validar cada elemento, que el name no este blanco.
        //Luego de enviar a guardar, los elementos que se devuelvan deben ser actualizados en el listado local.
        //Se deben gatillar los errores de los que no pudieron ser guardados.
        const aux_list = []
        
        listMasterKpis.filter(x => x.id <= 0).map((item, index) => (  
            aux_list.push({
                "id": item.id,
                "masterKpiNemo": "",
                "masterKpiCode": "",
                "name": item.name,
                "descripcion": item.descripcion,
    
                "typeOfId": item.typeOfId,
                "typeOfName": item.TypeOf_Id,
    
                "measurementUnitId": item.measurementUnitId,
                "measurementUnitName": item.MeasurementUnit_Id,
    
                "objetiveId": item.objetiveId,
                "objetiveName": item.Objetive_Id,
    
                "measurementPeriodId": item.measurementPeriodId,
                "timeAggregationId": item.timeAggregationId,
                "formulaId": item.formulaId,
                "statusId": item.statusId
            })
        ))
        
        if (isInValidFormControls(aux_list) === false) {
            addMasterKpiList(aux_list).then(() => {
                setListMasterKpis(null)
                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                setterActionFired("MantainerMasterKpi", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("MantainerMasterKpi", 1)
            });
        } else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
            setterActionFired("MantainerMasterKpi", 1)
        }
    };

    const onGetTemplateClick = (type) => {
        const linkExport = document.getElementById("btnGetTemplateJson");
        let exportFileName = "";
        let excelStrData = "Id;Name\n";
        
        switch (type) {
            case "TPOf":
                exportFileName = t('data-lang-lbl-typeof') + ".csv";
                listTypeOfs.forEach(element => {
                    excelStrData += element.key + ";" + element.title + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            case "MUnit":
                exportFileName = t('data-lang-lbl-measurementunit') + ".csv";
                listMeasurmentUnits.forEach(element => {
                    excelStrData += element.key + ";" + element.title + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            case "Obj":
                exportFileName = t('data-lang-lbl-objetives') + ".csv";
                listObjectives.forEach(element => {
                    excelStrData += element.key + ";" + element.title + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            case "Frm":
                exportFileName = t('data-lang-lbl-field-formulaid') + ".csv";
                listFormulaId.forEach(element => {
                    excelStrData += element.key + ";" + t(element.text) + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            case "Stat":
                exportFileName = t('data-lang-lbl-status') + ".csv";
                listStatusId.forEach(element => {
                    excelStrData += element.key + ";" + t(element.text) + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            case "Period":
                exportFileName = t('data-lang-lbl-measurementperiod') + ".csv";
                listPeriods.forEach(element => {
                    excelStrData += element.key + ";" + t(element.text) + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            case "Agg":
                exportFileName = t('data-lang-lbl-timeaggregation') + ".csv";
                listAgregations.forEach(element => {
                    excelStrData += element.key + ";" + t(element.text) + "\n"
                });
                downloadCSV(excelStrData, "data:text/csv;charset=utf-8,%EF%BB%BF", linkExport, exportFileName);
                break;
            case "Data":
                const btnGetTemplate = document.getElementById('btnGetTemplate');
                btnGetTemplate.click();
                break;
            default:
                break;
        }
    };

    const handlerSave = async (itemId) => {
        const item = gridRef.current.props.source.records.find(x => x.id === itemId);

        if (validateObject(item)) {
            if (item.id <= 0) {
                item.formulaId = item.formulaId === undefined ? 1 : item.formulaId;
                item.statusId = item.statusId === undefined ? 1 : item.statusId;
                item.masterKpiCode = "";
                item.masterKpiNemo = "";

                const newItem = {
                    "id": item.id,
                    "masterKpiNemo": item.masterKpiNemo,
                    "masterKpiCode": item.masterKpiCode,
                    "name": item.name,
                    "descripcion": item.descripcion,

                    "typeOfId": item.typeOfId,
                    "typeOfName": item.TypeOf_Id,

                    "measurementUnitId": item.measurementUnitId,
                    "measurementUnitName": item.MeasurementUnit_Id,

                    "objetiveId": item.objetiveId,
                    "objetiveName": item.Objetive_Id,

                    "measurementPeriodId": item.measurementPeriodId,
                    "timeAggregationId": item.timeAggregationId,
                    "formulaId": item.formulaId,
                    "statusId": item.statusId
                }

                await addMasterKpi(newItem).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id))

                        listMasterKpis.forEach(element => {
                            if (element.id === parseInt(item.id)) {
                                element.id = serviceResponse.data.data.id;
                                element.masterKpiCode = serviceResponse.data.data.masterKpiCode;
                            }
                        });

                        setListMasterKpis(listMasterKpis);
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                    setterActionFired("MantainerMasterKpi", 1)
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setterActionFired("MantainerMasterKpi", 1)
                });
            }
            else {

                item.masterKpiNemo = "";

                const newItem = {
                    "id": item.id,
                    "masterKpiNemo": item.masterKpiNemo,
                    "masterKpiCode": item.masterKpiCode,
                    "name": item.name,
                    "descripcion": item.descripcion,

                    "typeOfId": item.typeOfId,
                    "typeOfName": item.TypeOf_Id,

                    "measurementUnitId": item.measurementUnitId,
                    "measurementUnitName": item.MeasurementUnit_Id,

                    "objetiveId": item.objetiveId,
                    "objetiveName": item.Objetive_Id,

                    "measurementPeriodId": item.measurementPeriodId,
                    "timeAggregationId": item.timeAggregationId,
                    "formulaId": item.formulaId,
                    "statusId": item.statusId
                }

                saveMasterKpiById(itemId, newItem).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id))
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                    setterActionFired("MantainerMasterKpi", 1)
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setterActionFired("MantainerMasterKpi", 1)
                });
            } 

            setShowRequiredGlobalMessage(false);
        }
        else {
            setShowRequiredGlobalMessage(true);
        }
    };

    const handlerDelete = async (itemId) => {
        if (itemId <= 0) {
            const newListMasterKpis = listMasterKpis.filter(x => x.id !== itemId);
            setListMasterKpis(newListMasterKpis)
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
            setterActionFired("MantainerMasterKpi", 1)
        }
        else {
            await deleteMasterKpi(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    const newListMasterKpis = listMasterKpis.filter(x => x.id !== itemId);
                    setListMasterKpis(newListMasterKpis)
                    setEditingRows(editingRows.filter(x => x !== itemId));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("MantainerMasterKpi", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("MantainerMasterKpi", 1)
            });
        }
    };

    const handlerCancel = async (itemId) => {
        if (itemId === null) {
            const newListMasterKpis = listMasterKpis.filter(x => x.id !== itemId);
            setListMasterKpis(newListMasterKpis)
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
            setterActionFired("MantainerMasterKpi", 1)
        }
        else
        {
            await getMasterKpiById(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    listMasterKpis.forEach(element => {
                        if (serviceResponse.data.data.id === element.id) {
                            for (const property in serviceResponse.data.data) {
                                element[property] = serviceResponse.data.data[property]
                            }
                        }
                    });
            
                    setListMasterKpis(listMasterKpis);
                    setEditingRows(editingRows.filter(x => x !== itemId));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("MantainerMasterKpi", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("MantainerMasterKpi", 1)
            });
        }
    };

    const validateObject = (object) => {
        let isValid = object.name !== undefined && object.name !== null && object.name !== '';
        isValid = isValid ? object.typeOfId !== undefined && object.typeOfId !== null && object.typeOfId !== '' : isValid;
        isValid = isValid ? object.measurementPeriodId !== undefined && object.measurementPeriodId !== null && object.measurementPeriodId !== '' : isValid;
        isValid = isValid ? object.measurementUnitId !== undefined && object.measurementUnitId !== null && object.measurementUnitId !== '' : isValid;
        isValid = isValid ? object.statusId !== undefined && object.statusId !== null && object.statusId !== '' : isValid;
        isValid = isValid ? object.formulaId !== undefined && object.formulaId !== null && object.formulaId !== '' : isValid;
        isValid = isValid ? object.timeAggregationId !== undefined && object.timeAggregationId !== null && object.timeAggregationId !== '' : isValid;
        isValid = isValid ? object.objetiveId !== undefined && object.objetiveId !== null && object.objetiveId !== '' : isValid;

        return isValid;
    };

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return listMasterKpis[rowIndex.boundindex].id;
        }
        return listMasterKpis[rowIndex]?.id;
    };

    const onCellvaluechanged = (e) => {
        const currentColumn = e.owner._columns.find(x => x.datafield === e.args.datafield);

        if (currentColumn.columntype === "dropdownlist") {
            listMasterKpis[e.args.rowindex][e.args.datafield] = e.args.value.value
        }
        else {
            listMasterKpis[e.args.rowindex][e.args.datafield] = e.args.value
        }

        const copia_listMasterKpis = JSON.parse(JSON.stringify(listMasterKpis));
        setListMasterKpis(copia_listMasterKpis);

        if (editingRows.find(x => x === listMasterKpis[e.args.rowindex].id) === undefined) {
            editingRows.push(listMasterKpis[e.args.rowindex].id)
        }

        setEditingRows(editingRows);
        applyFilters(gridRef, 'MantainerMasterKpi', false);

        executeScrollMovementToFixLockRowOnEditCell(gridRef);
    };

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        const isEditing = editingRows.find(x => x === itemId);

        return  <>
                {
                    profileHasAccess &&
                    <>
                            {isEditing ? (
                                <>
                                    {
                                        itemId <= 0 ? (
                                            <>
                                                <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                                <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                            </>
                                        ) : (
                                            <>
                                                <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                                <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancelar" ariaLabel="Cancelar" onClick={() => fieldActionHandler(itemId, 'cancel')} />
                                                <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                            </>
                                        )
                                    }
                                </>
                            ) : (
                                <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                            )}
                        </>
                }
                </>
    };

    const fieldActionHandler = (itemId, actionType) => {
        switch (actionType) {
            case 'save':
                handlerSave(itemId)
                break;
            case 'delete':
                handlerDelete(itemId)
                break;
            case 'cancel':
                handlerCancel(itemId)
                break;
            default:
                break;
        }
    };

    const cellsRenderer = (rowIndex, cellValue, editor, cellText, width, height, auxListData, cellType, subType) => {
        switch (cellType) {
            case 'textbox':
                switch (subType) {
                    case "currency":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: false,
                            symbol: '$',
                            groupSeparator: ',',
                            decimalSeparator: '.',
                            digits: 19, 
                            max: 9999999999,
                        });
                        break;
                    case "number":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: true,
                            groupSeparator: ',',
                            decimalSeparator: '.',
                            digits: 19, 
                            max: 9999999999,
                        });
                        break;
                    default:
                        break;
                }
                break;
            case 'datetimeinput':
                break;
            case 'checkbox':
                editor.jqxCheckBox({ width: width });
                break;
                case 'dropdownlist':
                editor.jqxDropDownList({
                    width: width,
                    height: height,
                    source: getListColumnAdapter(auxListData, 'key', 'text'),
                    displayMember: 'text',
                    valueMember: 'key',
                    autoDropDownHeight: auxListData.length < 5
                });
            default:
                break;
        }
    };

    const cellRenderClassStyle = (row, columnfield, value, columnType) => {
        let className = "";
        switch (columnType) {
            case "textbox":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "numberinput":
                if (value < 0 || value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "datetimeinput":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "dropdownlist":
                if (value === null || value === '' || value === 0) {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break
            default:
                break;
        }

        return className;
    };

    const getListColumnAdapter = (listObjetcs, key, text) => {
        return new jqx.dataAdapter({
            datafields: [
                { name: text, type: 'string' },
                { name: key, type: 'number' }
            ],
            datatype: 'array',
            localdata: listObjetcs
        }, { autoBind: true });
    };

    const getColumns = () => {
        const basicColumns = [
            { index: null, text: 'ID',                                  dataField: 'id',                    uploadMasive: false, exportable: false, width: '0px',   columntype: 'textbox', editable: false, hidden: true },
            { index: null, text: t('data-lang-lbl-actions'),            dataField: 'acciones',              uploadMasive: false, exportable: false, width:  '100px', pinned: true,
                createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
            },
            { index: null, text: t('data-lang-lbl-code'),               dataField: 'masterKpiCode',         uploadMasive: false, exportable: true,  width: '100px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'),          columntype: 'textbox',        editable: false, pinned: true },
            { index: 0,    text: t('data-lang-lbl-name'),               dataField: 'name',                  uploadMasive: true,  exportable: true,  width: '350px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'),          columntype: 'textbox',        cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: profileHasAccess, pinned: true },
            { index: 1,    text: t('data-lang-lbl-description'),        dataField: 'descripcion',           uploadMasive: true,  exportable: true,  width: '300px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'),          columntype: 'textbox',        editable: profileHasAccess },
            { index: 2,    text: t('data-lang-lbl-typeof'),             dataField: 'typeOfId',              uploadMasive: true,  exportable: true,  width: '155px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listTypeOfs, 'dropdownlist'),        columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: profileHasAccess, displayfield: 'TypeOf_Id', editorOptions: listTypeOfs },
            { index: 3,    text: t('data-lang-lbl-measurementunit'),    dataField: 'measurementUnitId',     uploadMasive: true,  exportable: true,  width: '155px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listMeasurmentUnits, 'dropdownlist'),columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: profileHasAccess, displayfield: 'MeasurementUnit_Id', editorOptions: listMeasurmentUnits },
            { index: 4,    text: t('data-lang-lbl-objetive'),           dataField: 'objetiveId',            uploadMasive: true,  exportable: true,  width: '155px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listObjectives, 'dropdownlist'),     columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: profileHasAccess, displayfield: 'Objetive_Id', editorOptions: listObjectives },
            { index: 5,    text: t('data-lang-lbl-measurementperiod'),  dataField: 'measurementPeriodId',   uploadMasive: true,  exportable: true,  width: '220px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listPeriods, 'dropdownlist'),        columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: profileHasAccess, displayfield: 'MeasurementPeriod_Id', editorOptions: listPeriods },
            { index: 6,    text: t('data-lang-lbl-timeaggregation'),    dataField: 'timeAggregationId',     uploadMasive: true,  exportable: true,  width: '220px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listAgregations, 'dropdownlist'),    columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: profileHasAccess, displayfield: 'TimeAggregation_Id', editorOptions: listAgregations },
            { index: 7,    text: t('data-lang-lbl-formula'),            dataField: 'formulaId',             uploadMasive: true,  exportable: true,  width: '120px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listFormulaId, 'dropdownlist'),      columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: profileHasAccess, displayfield: 'Formula_Id', editorOptions: listFormulaId },
            { index: 8,    text: t('data-lang-lbl-status'),             dataField: 'statusId',              uploadMasive: true,  exportable: true,  width: '160px', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, listStatusId, 'dropdownlist'),       columntype: 'dropdownlist',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),  editable: profileHasAccess, displayfield: 'Status_Id', editorOptions: listStatusId },
        ]

        return basicColumns;
    };

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="h-100">
                <Card.Header>
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-maintainer-title-masterkpis')}</b></h4>
                    </Card.Title>
                </Card.Header>
                <Card.Footer>
                    <MessageBox
                        inputParam_Message={ messageConfig.message }
                        inputParam_Display={ messageConfig.showMessage }
                        inputParam_MessageType={ messageConfig.messageType }
                        inputParam_SetterMessage={ setMessageConfig }
                    />
                </Card.Footer>
                <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                    <div className="align-items-center h-100">
                        <div className="d-none">
                            <input ref={fileInputRef} type="file" accept=".xlsx" onChange={handlerFileUpload} />
                            <a id="btnGetTemplate" href={TemplateDoc} download="MasterKpiTemplate.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                            <a id="btnGetTemplateJson" href={undefined} download="Template.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                        </div>
                        {
                            listTypeOfs && listMeasurmentUnits && listObjectives && listPeriods && listAgregations && listFormulaId && listStatusId && listMasterKpis &&
                            <>
                                <MatrixToolbar
                                    inputParam_HandleSaveData={handlerSaveAll}
                                    inputParam_HandleUploadData={handlerUploadData}
                                    inputParam_HandleExportData={handlerExportData}
                                    inputParam_HandleAddRow={handlerAddNewRow}
                                    inputParam_Configuration={{
                                        buttons: {
                                            showRowButtons: profileHasAccess,
                                            showExportData: true,
                                            showAddMasiveData: profileHasAccess,
                                            showAddData: profileHasAccess,
                                            showDownloadTemplate: profileHasAccess,
                                            showSaveAllData: profileHasAccess,
                                            groupedButtons: profileHasAccess
                                        },
                                        handlers: {
                                            handlerSave: profileHasAccess ? handlerSave : null,
                                            handlerSaveAll: profileHasAccess ? handlerSaveAll : null,
                                            handlerDelete: profileHasAccess ? handlerDelete : null,
                                            handlerCancel: profileHasAccess ? handlerCancel : null,
                                        },
                                        auxiliarListCallbackOnAdd: null,
                                    }}
                                    inputParam_ExternalExportTemplates={[
                                        {
                                            id: 'btnMantGetTemplate',
                                            key: 'btnMantGetTemplate',
                                            text: t('data-lang-lbl-uploadtemplate'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => handlerExportData(false)
                                        },
                                        {
                                            id: 'btnMantGetTemplateTPOf',
                                            key: 'btnMantGetTemplateTPOf',
                                            text: t('data-lang-lbl-typeof'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => onGetTemplateClick('TPOf')
                                        },
                                        {
                                            id: 'btnMantGetTemplateMUnit',
                                            key: 'btnMantGetTemplateMUnit',
                                            text: t('data-lang-lbl-measurementunit'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => onGetTemplateClick('MUnit')
                                        },
                                        {
                                            id: 'btnMantGetTemplateObj',
                                            key: 'btnMantGetTemplateObj',
                                            text: t('data-lang-lbl-objetives'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => onGetTemplateClick('Obj')
                                        },
                                        {
                                            id: 'btnMantGetTemplateFrm',
                                            key: 'btnMantGetTemplateFrm',
                                            text: t('data-lang-lbl-field-formulaid'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => onGetTemplateClick('Frm')
                                        },
                                        {
                                            id: 'btnMantGetTemplateStat',
                                            key: 'btnMantGetTemplateStat',
                                            text: t('data-lang-lbl-status'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => onGetTemplateClick('Stat')
                                        },
                                        {
                                            id: 'btnMantGetTemplatePeriod',
                                            key: 'btnMantGetTemplatePeriod',
                                            text: t('data-lang-lbl-measurementperiod'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => onGetTemplateClick('Period')
                                        },
                                        {
                                            id: 'btnMantGetTemplateAgg',
                                            key: 'btnMantGetTemplateAgg',
                                            text: t('data-lang-lbl-timeaggregation'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => onGetTemplateClick('Agg')
                                        }
                                    ]}
                                    inputParam_CustomOpenPanel={false}
                                    showRequiredMessage={showRequiredGlobalMessage}
                                />
                                <JqxGrid
                                    ref={gridRef}
                                    altrows={true}
                                    enabletooltips={true}
                                    width={'100%'}
                                    theme={'light'} 
                                    height={'500px'}
                                    editable={true}
                                    sortable={true}
                                    filterable={true}
                                    showfilterrow={true} 
                                    localization={getGridLocalization(t)}
                                    source={ new jqx.dataAdapter({
                                        localData: listMasterKpis,
                                        dataType: 'array',
                                        dataFields: [
                                            { name: 'id',                    type: 'number' },
                                            { name: 'masterKpiCode',         type: 'string' },
                                            { name: 'name',                  type: 'string' },
                                            { name: 'descripcion',           type: 'string' },
                                            
                                            { name: 'typeOfId',              type: 'number' },
                                            { name: 'TypeOf_Id',              value: 'typeOfId', values: { source: listTypeOfs, value: 'key', name: 'text' } },
                                            
                                            { name: 'measurementUnitId',     type: 'number' },
                                            { name: 'MeasurementUnit_Id',     value: 'measurementUnitId', values: { source: listMeasurmentUnits, value: 'key', name: 'text' } },
                                            
                                            { name: 'objetiveId',            type: 'number' },
                                            { name: 'Objetive_Id',            value: 'objetiveId', values: { source: listObjectives, value: 'key', name: 'text' } },
                                            
                                            { name: 'measurementPeriodId',   type: 'number' },
                                            { name: 'MeasurementPeriod_Id',   value: 'measurementPeriodId', values: { source: listPeriods, value: 'key', name: 'text' } },
                                            
                                            { name: 'timeAggregationId',     type: 'number' },
                                            { name: 'TimeAggregation_Id',     value: 'timeAggregationId', values: { source: listAgregations, value: 'key', name: 'text' } },
                                            
                                            { name: 'formulaId',             type: 'number' },
                                            { name: 'Formula_Id',             value: 'formulaId', values: { source: listFormulaId, value: 'key', name: 'text' } },
                                            
                                            { name: 'statusId',              type: 'number' },
                                            { name: 'Status_Id',              value: 'statusId', values: { source: listStatusId, value: 'key', name: 'text' } },
                                        ],
                                        id: 'id'
                                    })}
                                    columns={getColumns()}
                                    onCellvaluechanged={onCellvaluechanged}
                                    onFilter={(event) => handlerFilter(event, 'MantainerMasterKpi')}
                                />
                            </>
                        }
                    </div>
                </Card.Body>
            </Card>           
        </div>
    ); 
}